import React, {ReactElement, JSXElementConstructor,createContext } from "react";
import {ThemeContext} from './theme.context';


export const ThemeProvider = ({children}: {children: ReactElement<any, string | JSXElementConstructor<any>>}) =>{
    const [theme, setTheme] = React.useState('');
    const changeTheme = (theme:string) =>{
        setTheme(theme);
    }

    return (
        <ThemeContext.Provider value={{theme, changeTheme}}>
            {children}
        </ThemeContext.Provider>
    )
}